/**
 * Branding helpers — applies the active client's accent color + logo
 * everywhere in the portal. Lives on `window.repliantBranding` so any
 * component can grab it without prop-drilling.
 */
import { useEffect, useState } from "react";

const STORAGE_KEY = "ra_branding";

export function setBranding(branding) {
  if (branding) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(branding));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export function getBranding() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "null");
  } catch {
    return null;
  }
}

/** Hex with alpha — `withAlpha("#FFB000", 0.15)` → `rgba(255,176,0,0.15)` */
export function withAlpha(hex, alpha = 1) {
  if (!hex) return `rgba(255,176,0,${alpha})`;
  const m = hex.replace("#", "");
  const full = m.length === 3 ? m.split("").map((c) => c + c).join("") : m;
  const r = parseInt(full.slice(0, 2), 16);
  const g = parseInt(full.slice(2, 4), 16);
  const b = parseInt(full.slice(4, 6), 16);
  return `rgba(${r},${g},${b},${alpha})`;
}

/** Hook that returns current branding (re-renders if it changes via storage) */
export function useBranding() {
  const [branding, setLocal] = useState(getBranding());
  useEffect(() => {
    const handler = () => setLocal(getBranding());
    window.addEventListener("storage", handler);
    return () => window.removeEventListener("storage", handler);
  }, []);
  return branding;
}
